<template lang="pug">
.v-feedbacks.feedbacks(v-if="feedbacks")
	.feedbacks__videos(v-if="feedbacks.items")
		.feedbacks__videos-wrapper(v-if="isVisible")
			button.feedbacks__arrow.feedbacks__arrow--prev(type="button" ref="fed-prev" aria-label="Предыдущий слайд")
				v-svg-icon.feedbacks__arrow-icon(icon="slide-left")
				v-svg-icon.feedbacks__arrow-bg(icon="slide-left-bg")
			button.feedbacks__arrow.feedbacks__arrow--next(type="button" ref="fed-next" aria-label="Следующий слайд")
				v-svg-icon.feedbacks__arrow-icon(icon="slide-right")
				v-svg-icon.feedbacks__arrow-bg(icon="slide-right-bg")
			v-swiper-slider.feedbacks__slider(:options="options"
					:navigation="navigation"
					@slide-change="onSlideChange"
					@swiper="onSwiper")
				template(v-if="isSm")
					swiper-slide(v-for="(feedback, feedbackIndex) in feedbacks.items.slice(0, 7)"
							:key="feedbackIndex"
							v-if="feedbacks.items && feedbacks.items.length")
						template(v-if="feedbackIndex >= 0 && feedbackIndex <= 5")
							.feedbacks__video-wrapper(@click="wasOpen[feedbackIndex] = true"
									:class="{'feedbacks__video--active': wasOpen[feedbackIndex]}")
								template(v-if="!(realIndex === feedbackIndex) || wasOpen[feedbackIndex]")
									.reviews__video-link(@click="playVideo(feedback)")
										img.feedbacks__video(:src="feedback.video.poster"
												alt=""
												loading="lazy")
										.feedbacks__video-gradient
											v-svg-icon.feedbacks__video-icon(icon="triangle")
											.feedbacks__video-text(v-if="feedback.text") {{feedback.text}}
								template(v-if="(realIndex === feedbackIndex) && !wasOpen[feedbackIndex]")
									v-video.feedbacks__video(:src="feedback.video.src"
											:type="feedback.video.type"
											:autoplay="videoOptions.autoplay"
											:controls="videoOptions.controls"
											:muted="videoOptions.muted"
											:modalClass="videoOptions.modalClass"
											:modalProp="videoOptions.modalProp"
											:index="feedbackIndex"
											@click="clickLinkedVideo(feedbackIndex)")
						template(v-else)
							a.feedbacks__video-wrapper.feedbacks__video-wrapper--link(:href="feedbacks.link"
									target="_blank")
								.feedbacks__video-link-text {{computedTextLink}}
								.feedbacks__video-icon-circle
									v-svg-icon.feedbacks__video-link-icon(icon="arrow-big-right")
				template(v-else)
					swiper-slide(v-if="feedbacks.items && feedbacks.items.length"
							v-for="(feedback, feedbackIndex) in feedbacks.items"
							:key="feedbackIndex")
						transition(name="fade")
							.feedbacks__video-wrapper(
									@mouseover="resetHoveredStates(feedbackIndex)"
									@mouseleave="isHovered[feedbackIndex] = false"
									@click="wasOpen[feedbackIndex] = true"
									:class="{'feedbacks__video--active': wasOpen[feedbackIndex]}")
								template(v-if="!isHovered[feedbackIndex]")
									img.feedbacks__video(:src="feedback.video.poster"
											alt=""
											loading="lazy")
									.feedbacks__video-gradient
										v-svg-icon.feedbacks__video-icon(icon="triangle")
										.feedbacks__video-text(v-if="feedback.text") {{feedback.text}}
								template(v-if="isHovered[feedbackIndex]")
									v-video.feedbacks__video(:src="feedback.video.src"
											:type="feedback.video.type"
											:autoplay="videoOptions.autoplay"
											:controls="videoOptions.controls"
											:muted="videoOptions.muted"
											:modalClass="videoOptions.modalClass"
											:modalProp="videoOptions.modalProp"
											:index="feedbackIndex"
											@click="clickLinkedVideo(feedbackIndex)")
	v-feedbacks-media.feedbacks__feedbacks-media(:data-source="feedbacks.medias" v-if="isVisible" )
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import breakpoints from '../scripts/breakpoints.js';
import {SwiperSlide} from 'swiper/vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import isGetPreviewMixin from '../components/mixins/v-mixin-get-preview.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin,
		isMobMixin,
		isGetPreviewMixin,
	],

	components: {
		SwiperSlide
	},

	data() {
		return {
			feedbacks: null,
			imageItems: [],
			realIndex: 0,
			firstLoad: true,
			swiperInstance: null,
			videoOptions: {
				"autoplay": true,
				"muted": true,
				"controls": false,
				'modalClass': 'modal--mini',
				'modalProp': {
					"autoplay": true,
					"muted": false,
					"modalClass": false,
					"controls": true,
				}
			},
			wasOpen: {},
			isHovered: {},
			isVisible: false,
			observer: null,
			postersLoaded: false,
			allVideoImage: '/local/assets/images/placeholder-youtube.png',
			options: {
				loop: true,
				breakpoints: {
					[breakpoints['md-min']]: {
						spaceBetween: 10,
						slidesPerView: 'auto'
					},
					[breakpoints['4xs-min']]: {
						spaceBetween: 6,
						loop: false,
						slidesPerView: 'auto'
					}
				}
			},
			allowTouchMove: true,
			pagination: {
				clickable: false
			},
			navigation: false
		};
	},

	beforeUnmount() {
		if (this.observer) {
			this.observer.disconnect();
		}
	},

	watch: {
		country(newValue, oldValue) {
			if (newValue !== oldValue) {
				const cacheKey = this.getCacheKey();
				const cachedPosters = sessionStorage.getItem(cacheKey);
				sessionStorage.removeItem(cachedPosters);
				this.requestDataLoad()
			}
		}
	},

	computed: {
		country() {
			return this.$store.getters['delivery/country'];
		},

		computedTextLink() {
			if(this.feedbacks.linkText) {
				return this.feedbacks.linkText
			} else if (this.country.value === 'rf') {
				return 'Все видео на Rutube'
			} else {
				return 'Все видео на YouTube'
			}
		}
	},

	methods: {
		resetHoveredStates(currentIndex) {
			this.isHovered[currentIndex] = true;
			for (const key in this.isHovered) {
				if (Number(key) !== currentIndex) {
					this.isHovered[key] = false;
				}
			}
		},

		async onObserver() {
			if(this.isVisible || this.observer) return
			try {
				if (!this.$el) {
					console.warn('Элемент this.$el не определен.');
					await this.loadPosters();
					this.isVisible = true
					return;
				}
				if (typeof IntersectionObserver === 'undefined') {
					console.warn('IntersectionObserver не поддерживается.');
					await this.loadPosters();
					this.isVisible = true;
					return;
				}
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach(async (entry) => {
						if (entry.isIntersecting) {
							await this.loadPosters();
							this.isVisible = true;
							this.observer.unobserve(entry.target);
						}
					});
				});
				this.observer.observe(this.$el);
			} catch (error) {
				console.error('Ошибка при создании IntersectionObserver:', error);
				await this.loadPosters();
				this.isVisible = true;
			}
		},

		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['fed-prev'],
				nextEl: this.$refs['fed-next']
			};
		},

		clickLinkedVideo(index) {
			this.wasOpen[index] = true;
			this.isHovered[index] = false
		},

		onSlideChange(swiper) {
			this.realIndex = swiper.realIndex;
		},

		playVideo(data) {
			controller.openModal({
				className: 'modal--mini',
				component: {
					name: 'v-video',
					props: {...data.video, poster: null, ...this.videoOptions.modalProp}
				}
			});
		},

		checkPostersInStorage() {
			const cacheKey = this.getCacheKey();
			const cachedPosters = sessionStorage.getItem(cacheKey);
			if (cachedPosters) {
				this.feedbacks.items = JSON.parse(cachedPosters);
				this.postersLoaded = true;
			} else if (this.isVisible) {
				this.loadPosters()
			}
		},

		requestDataLoad() {
			if (this.feedbacks && this.feedbacks.remote) {
				this.dataLoad({
					url: this.feedbacks.remote,
					delay: true,
					data: {
						name: String(this.getLastPartOfUrl()),
						country: this.country.value
					}
				})
			}
		},

		async loadPosters() {
			if (this.postersLoaded) return;
			if (this.feedbacks.items && this.feedbacks.items.length) {
				const imageItemsPromises = this.feedbacks.items.map(async (review) => {
					if (review.video.poster) {
						return review;
					} else {
						try {
							const poster = await this.getPreview(review.video.src);
							return { ...review, video: { ...review.video, poster } };
						} catch (error) {
							console.error('Ошибка при получении preview:', error);
							return review;
						}
					}
				});
				const cacheKey = this.getCacheKey();
				const cachedPosters = sessionStorage.getItem(cacheKey);
				if ((!cachedPosters && this.firstLoad) || this.feedbacks.update) {
					this.imageItems = await Promise.all(imageItemsPromises);
					this.feedbacks.items = this.imageItems;
					this.postersLoaded = true;
					this.feedbacks.update = false;
					sessionStorage.setItem(cacheKey, JSON.stringify(this.feedbacks.items));
				} else {
					this.checkPostersInStorage()
				}
			}
			if(this.firstLoad) {
				this.firstLoad = false
			}
		},

		getLastPartOfUrl() {
			const path = window.location.pathname;
			const parts = path.split('/').filter(part => part);
			return parts[parts.length - 1] || 'default';
		},

		getCacheKey() {
			const lastPart = this.getLastPartOfUrl();
			return `feedbacksPosters_${lastPart}_${this.country?.value}`;
		},

		dataSet(data) {
			this.feedbacks = data;
			this.postersLoaded = false;
			this.checkPostersInStorage()
			this.$nextTick(() => {
				this.onObserver();
			});
		}
	}
};
</script>